import React from "react";

export const FacebookIcon = ({ width = "9", height = "13" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.507 8.43809L7.924 5.72509H5.319V3.96109C5.30089 3.75843 5.32859 3.55429 5.40004 3.36378C5.47149 3.17327 5.58487 3.00127 5.73178 2.8605C5.8787 2.71973 6.05539 2.6138 6.24877 2.55055C6.44216 2.4873 6.6473 2.46835 6.849 2.49509H8.029V0.184094C7.33439 0.0720179 6.63252 0.0108554 5.929 0.00109473C5.44475 -0.0354468 4.95838 0.0348855 4.50432 0.207115C4.05026 0.379345 3.63959 0.649262 3.30139 0.997767C2.96319 1.34627 2.70571 1.76485 2.54719 2.22387C2.38866 2.6829 2.33295 3.17116 2.384 3.65409V5.72509H0V8.44009H2.384V15.0001H5.319V8.43809H7.507Z"
        fill="#FF5F00"
      />
    </svg>
  );
};
